import request from "@/util/request.js";
export const getSmCode = ({ mobile }) =>
  request({
    url: "/admin/mobile/smsCodeSend",
    method: "POST",
    data: {
      deviceType: 5,
      mobile,
      type: "LOGIN",
    },
  });

const grant_type = "mobile";
export const mobileLogin = (mobile, code) =>
  request({
    url: "/auth/mobile/token/sms",
    headers: {
      isToken: false,
      "TENANT-ID": "",
      Authorization: "Basic aDU6aDU=",
    },
    method: "POST",
    params: { mobile: "SMS@" + mobile, code: code, grant_type, device_type: 5 },
  });
